import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from "src/environments/environment";
import { CustomerAddress } from 'src/app/models/customer-address';
import { TravelService } from 'src/app/services/travel.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-expenses-total-report',
  templateUrl: './expenses-total-report.component.html',
  styleUrls: ['./expenses-total-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class ExpensesTotalReportComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  loading:boolean = false;
  data:any = [];
  orderBy = (a, b) => {
    if (typeof a.key == 'number' && typeof b.key == 'number') {
      if(a.key < b.key) return b.key;
    } else {
      return a.key;
    }
  }
  type:string = 'No Economico';
  realType:string = 'unity';

  idClick:number = 0;
  address:CustomerAddress = null;
  idSelected:number = null;
  price:number = 0;
  update_all:boolean = false;

  //total variables
  _ton = 0;
  _travels = 0;
  _lts = 0;
  _km = 0;
  _diesel_proeco = 0;
  _diesel_foraneo = 0;
  _diesel_total = 0;
  _gas_proeco = 0;
  _gas_foraneo = 0;
  _gas_total = 0;
  _travel_expenses = 0;
  _extra_expenses = 0;
  _maintenance_expenses = 0;
  _insurance_expenses = 0;
  _operator_paysheet = 0;
  _helper_1_paysheet = 0;
  _helper_2_paysheet = 0;
  _total_paysheet = 0;
  _total_expenses = 0;
  _profit = 0;

  //Puede Actualizar Precio Mercado
  updateMarketPrice: boolean = false;
  //Puede Cuadrar
  puedeCuadrar: boolean = false;

  constructor(
    private reportServ:ReportService, private modal:NgbModal, private travelServ:TravelService, private authService:AuthService, private toastr: ToastrManager, 
    private utl: UtilitiesService
  ) { }

  ngOnInit() {
    this.updateMarketPrice = this.authService.has('update-market-price-travels'); //Puede actualizar precio mercado
    this.puedeCuadrar = this.authService.can('can-cuadre'); //Puede actualizar precio mercado
  }

  openM(m, address:CustomerAddress, id:number, price:number) {
    this.address = address;
    this.idSelected = id;
    this.price = price;
    this.modal.open(m, { size: 'lg'});
  }

  storePm(event, m) {
    event.preventDefault();

    this.loading = true;
    this.travelServ.postMarketPrice(this.idSelected, {price: this.price, customer_address_id: this.address.id, update_all: this.update_all})//update market price
      .then(resp => {
        this.search();
        m.dismiss('Save click');
        this.loading = false;
        this.toastr.successToastr('Precio de mercado actualizado correctamente.', '', {enableHTML: true});
      }, error => {
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      });
  }

  savePm() {
    this.loading = true;
    this.travelServ.saveMarketPrice(this.date1, this.date2, this.realType)//update market price
      .then(resp => {
        this.search();
        this.loading = false;
        this.toastr.successToastr('Precio de mercado establecido correctamente.', '', {enableHTML: true});
      }, error => {
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      });
  }

  search () {
    this.loading = true;
    this.calcType();
    this.reportServ.totalExpensesReport(this.date1, this.date2, this.realType).then(data => {
      this.data = data;
      this.alldata = data;
      this.unitFilterActive = this.realType == 'unity';
      if(this.selectedUnit && this.realType == 'unity'){
        this.filter();
      }else{
        this.selectedUnit = null;
        this.resetTotals();
        this.calcTotals();
      }
      this.loading = false;
    });
  }

  calcType() {
    if (this.realType == 'unity') {
      this.type = 'No Economico';
    } else if(this.realType == 'product') {
      this.type = 'Producto';
    } else if(this.realType == 'product_type') {
      this.type = 'Tipo Producto';
    } else if(this.realType == 'customer') {
      this.type = 'Cliente';
    }
  }

  calcTotals() {
    for (var key in this.data) {
      for (let j = 0; j < this.data[key].travels.length; j++) {
        let tr = this.data[key].travels[j];
        this._ton += Number(tr.ton);
        this._travels += Number(tr.num_lines);
        this._lts += Number(tr.lts);
        this._km += Number(tr.km);
        this._diesel_proeco += Number(tr.diesel_proeco);
        this._diesel_foraneo += Number(tr.diesel_foraneo);
        this._diesel_total += Number(tr.diesel_total);
        this._gas_proeco += Number(tr.gas_proeco);
        this._gas_foraneo += Number(tr.gas_foraneo);
        this._gas_total += Number(tr.gas_total);
        this._travel_expenses += Number(tr.travel_expenses);
        this._extra_expenses += Number(tr.extra_expenses);
        this._maintenance_expenses += Number(tr.maintenance_expenses);
        this._insurance_expenses += Number(tr.insurance_expenses);
        this._operator_paysheet += Number(tr.operator_paysheet);
        this._helper_1_paysheet += Number(tr.helper_1_paysheet);
        this._helper_2_paysheet += Number(tr.helper_2_paysheet);
        this._total_paysheet += Number(tr.total_paysheet);
        this._total_expenses += Number(tr.total_expenses);
        this._profit += Number(tr.profit);
      }
    }
  }

  resetTotals() {
    this._ton = 0;
    this._travels = 0;
    this._lts = 0;
    this._km = 0;
    this._diesel_proeco = 0;
    this._diesel_foraneo = 0;
    this._diesel_total = 0;
    this._gas_proeco = 0;
    this._gas_foraneo = 0;
    this._gas_total = 0;
    this._travel_expenses = 0;
    this._extra_expenses = 0;
    this._maintenance_expenses = 0;
    this._insurance_expenses = 0;
    this._operator_paysheet = 0;
    this._helper_1_paysheet = 0;
    this._helper_2_paysheet = 0;
    this._total_paysheet = 0;
    this._total_expenses = 0;
    this._profit = 0;
  }

  total(travels, column = null) {
    let value = 0;
    for (let j = 0; j < travels.length; j++) {
      let tr = travels[j];

      value += column ? Number(tr[column]) : 1;
    }

    return value;
  }

  download() {
    window.open(environment.baseUrl + '/excel/expenses/details?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + '&type=' + this.realType, '_blank')
  }

  downloadPDF() {
    window.open(environment.baseUrl + '/pdf/expenses/details?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + '&type=' + this.realType, '_blank')
  }

  saveId(id:number){
    this.idClick = id;
  }

  mesSeleccionado: number|null = null;
  meses: { nombre: string, value: number }[] = [];
  modalRef: any;
  modalRef2: any;
  resultadoMant: string = '';
  resultadoRS: string = '';
  listDiferencias : any;

  
  openModal(m:any) {
    this.onChangeMes();
    const nombres = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    const hoy = new Date();
    const mesActual = hoy.getMonth(); 

    this.meses = [];

    for (let i = 0; i < mesActual; i++) {
      this.meses.push({
        nombre: nombres[i],
        value: i + 1 
      });
    }
    this.modalRef = this.modal.open(m, { size: 'lg',centered: true });
  }

  cuadre(resultadoModal: any){
    this.loading = true;
    this.reportServ.cuadre(this.mesSeleccionado).then(response => {
      this.loading = false;

      if (response.success) {
        this.modalRef.close();
        let mant = '';
        let rs = '';
        let errmant = '';
        let errrs = '';
        if (response.data && !Array.isArray(response.data)) {

          if (response.data['Mantenimiento']) {
            mant = response.data['Mantenimiento'].join(' - ');
          }

          if (response.data['Rentas/Seguros']) {
            rs = response.data['Rentas/Seguros'].join(' - ');
          }
          if (response.data['MantenimientoError']) {
            errmant = response.data['MantenimientoError'].join(' - ');
          }

          if (response.data['Rentas/SegurosError']) {
            errrs = response.data['Rentas/SegurosError'].join(' - ');
          }
          console.log('MantenimientoError');
          console.log(errmant);
          console.log('Rentas/SegurosError');
          console.log(errrs);
          
        }

        // ----------MODAL----------
        this.resultadoMant = mant;
        this.resultadoRS = rs;
        
        this.modalRef2 = this.modal.open(resultadoModal, { size: 'lg' });
        // setTimeout(() => {
        //   this.modalRef2.close();
        // }, 5000);
        // ----------MODAL----------
          

        // if (!mant && !rs) {
        //   alert(response.message || 'No hay datos para cuadrar');
        // } else {
        //   alert(
        //     `Cuadre realizado correctamente\n\n` +
        //     `Mantenimiento:\n${mant}\n` +
        //     `Rentas/Seguros:\n${rs}`
        //   );
        // }
      } else {
        alert(response.message || 'Error al realizar el cuadre');
      }
    }).catch(() => {
      this.loading = false;
      alert('Error de conexión');
    });
  }
  onChangeMes() {
    this.listDiferencias = null;
  }
  buscarDiferencias(){
    this.loading = true;

    this.reportServ.repDiferencias(this.mesSeleccionado,this.realType).then(resp => {
      this.listDiferencias = resp.data;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
      alert('Error de conexión');
    });
  }

  getDiferencia(item:any) {
    const total = item && item.total_mantenimiento ? item.total_mantenimiento : 0;
    const expenses = item && item.maintenance_expenses ? item.maintenance_expenses : 0;

    return Math.abs(total - expenses);
  }

  alldata:any = [];
  selectedUnit:any = null;
  unitFilterActive = true;
  filter() {
    if(this.selectedUnit){
      this.data = this.alldata[this.selectedUnit]
      ? { [this.selectedUnit]: this.alldata[this.selectedUnit] }
      : {};
    }else{
      this.data = this.alldata;
    }
    this.resetTotals();
    this.calcTotals();
  }

}//FIN DE CLASE
